import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function changeProfileImage(base64Image) {
  const response = await apiRequest({
    method: "put",
    path: "/profile/avatar",
    data: { base64_image: base64Image },
    errorMessage: "Erro ao atualizar imagem de perfil",
  });

  return unwrapProfileResponse(response);
}
